import ArchiveDocumentRepository from "../domain/data/ArchiveDocumentRepository";
import { ArchiveDocument, ArchiveFile } from "../domain/entities/ArchiveDocument";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APIArchiveDocumentRepository
  implements ArchiveDocumentRepository
{
  private client = new AwsApiClient();

  async searchArchive(
    orgId: string,
    lastName: string,
    firstName: string,
    studentId: string
  ): Promise<ArchiveDocument[]> {
    try {
      const params = new URLSearchParams();
      if (lastName) params.append("lastName", lastName);
      if (firstName) params.append("firstName", firstName);
      if (studentId) params.append("studentId", studentId);
      const response = await this.client.get(
        `/api/archive/search/${orgId}?${params.toString()}`
      );
      return response;
    } catch (error) {
      throw new Error(`Error searching archive: ${error}`);
    }
  }

  async listArchiveFiles(
    orgId: string,
    folderId: string
  ): Promise<ArchiveFile[]> {
    try {
      const response = await this.client.get(
        `/api/archive/files/${orgId}/${folderId}`
      );
      return response;
    } catch (error) {
      throw new Error(`Error listing archive files: ${error}`);
    }
  }

  async getArchiveFile(
    orgId: string,
    folderId: string,
    fileName: string
  ): Promise<Blob> {
    try {
      const response = await this.client.get(
        `/api/archive/file/${orgId}/${folderId}?fileName=${encodeURIComponent(fileName)}`,
        "blob"
      );
      return response;
    } catch (error) {
      throw new Error(`Error downloading archive file: ${error}`);
    }
  }

  async getOrderData(
    orgId: string,
    folderId: string
  ): Promise<Record<string, any>> {
    try {
      const response = await this.client.get(
        `/api/archive/order/${orgId}/${folderId}`
      );
      return response;
    } catch (error) {
      throw new Error(`Error fetching order data: ${error}`);
    }
  }
}
